import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
// types
import type { IProfileRisk } from "src/Interfaces/coveredCall";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

export interface CoveredCallSliceState {
  riskProfile: IProfileRisk;
  riskProfiles: DropdownItem[];
}

const initialState: CoveredCallSliceState = {
  riskProfile: {} as IProfileRisk,
  riskProfiles: [],
};

const CoveredCallSlice = createSlice({
  name: "coveredCall",
  initialState,
  reducers: {
    setRiskProfile: (store, action: PayloadAction<IProfileRisk>) => {
      store.riskProfile = { ...store.riskProfile, ...action.payload };
    },

    setRiskProfiles: (store, action: PayloadAction<DropdownItem[]>) => {
      store.riskProfiles = [...action.payload];
    },
  },
});

export const { setRiskProfile, setRiskProfiles } = CoveredCallSlice.actions;
export default CoveredCallSlice.reducer;
